// extracted by mini-css-extract-plugin
export default {"p":"getFriendRequest_p_cxl84"};